export interface IRESTClient {
    Authenticate(authCode: string): Promise<any>;
    GetNumber(token:string): Promise<any>;
    RenewNumber(number: string, renewalCode: string, token:string): Promise<any>;
    GetAgent(number: string, token:string): Promise<any>;
}

/**
 * This is the run time implementation of the RESTClient Interface. This interface is intended to be used with real configurations during dev, qa and production.
 */
export class RESTClientImpl implements IRESTClient {
    private static Instance: IRESTClient;
    private static restApiBaseUri: string;
    private static IdToken: string;

    /** Singleton implementation w/ private constructor so we dont accidently create more than one instance of the rest client. (Not thread safe if that matters.) */
    private constructor(restApiBaseUri: string) {RESTClientImpl.restApiBaseUri = restApiBaseUri}    

    static CreateInstance(restApiBaseUri:string) {
        if(RESTClientImpl.Instance)
            return RESTClientImpl.Instance;
        RESTClientImpl.Instance = new RESTClientImpl(restApiBaseUri);
        return RESTClientImpl.Instance
    }

    static SetToken(token: string) { RESTClientImpl.IdToken = token;}
    static GetIdToken() { return RESTClientImpl.IdToken || undefined; }
    static GetEndPoint() { return RESTClientImpl.restApiBaseUri; }

    async Authenticate(authCode: string): Promise<any> {
        let uri = process.env.REACT_APP_AUTH_BASE!.concat('/oauth2/token');
        let request = {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            body: new URLSearchParams({
                grant_type: "authorization_code",
                code: authCode,
                redirect_uri: process.env.REACT_APP_REDIRECT!,
                client_id: process.env.REACT_APP_REST_CLIENT_ID!
            })
        }

        console.log(request)
        const response = await fetch(uri, request)
            .then(response => response.json())
            .then(data => {
                RESTClientImpl.SetToken(data.id_token);
                return data;
            }).catch(e => console.log(e));
        console.log(response);
        return response;
    }

    async GetNumber(token: string): Promise<any> {
        let uri = RESTClientImpl.restApiBaseUri.concat('/create');
        let request = {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Authorization' : 'Bearer '.concat(token)}
        }

        const fetchResponse = await fetch(uri, request)
        .then(response => response.json())
        .then(data => {return data})
        .catch(error => { console.log(`Error fetching data: ${error}`); });

        return fetchResponse;
    }

    async RenewNumber(number: string, renewalCode: string, token: string): Promise<any> {
        let uri = RESTClientImpl.restApiBaseUri.concat('/renew/').concat(number).concat('/').concat(renewalCode);
        let request = {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Authorization' : 'Bearer '.concat(token)}
        }

        const fetchResponse = await fetch(uri, request)
        .then(response => response.json())
        .then(data => {return data})
        .catch(error => { console.log(`Error fetching data: ${error}`); });

        return fetchResponse;
    }

    async GetAgent(number: string, token: string): Promise<any> {
        let uri = RESTClientImpl.restApiBaseUri.concat('/').concat(number);
        let request = {
            method: 'GET',
            headers: {
                'Accept': '*/*',
                'Authorization' : 'Bearer '.concat(token)}
        }

        const fetchResponse = await fetch(uri, request)
        .then(response => response.json())
        .then(data => {return data})
        .catch(error => { console.log(`Error fetching data: ${error}`); });

        return fetchResponse;
    }
}